export default __webpack_public_path__ + "static/media/logo.d48fedc0.png";